import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { breadcrumb, breadcrumbResolve, breadcrumbResolved } from 'rise-ui/services/breadcrumb.js';
import { topics } from 'rise-ui/services/help-search.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class HelpRoute extends Route {
  @service router;

  @breadcrumb crumb = 'Help';

  model(params) {
    return {
      helpTopicField: {
        allowedValues: {
          '': 'All Topics',
          topic2: topics.topic2,
          topic3: topics.topic3,
          topic4: topics.topic4,
          // topic5: topics.topic5,
          topic7: topics.topic7,
          topic8: topics.topic8,
          topic9: topics.topic9,
        },
      },
    };
  }

  @breadcrumbResolve modelCrumbResolve() {
    return this.router.isActive('help.page');
  }
  @breadcrumbResolved modelCrumb(model) {
    return [ 'Help', ...(this.router.isActive('help.page') ? ['Topics'] : []) ];
  }
}
